module.exports = __webpack_public_path__ + "img/press-media-hero.c1791c8e.png";